module.exports = __webpack_public_path__ + "img/1.8ffca22e.png";